import { search } from "../../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/prouser/empresa/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findEmpresas(empresa_cnpj, id) {
  return search(
    `${path}${id ? `/${id}` : ""}?empresa_cnpj=${empresa_cnpj}`,
    "GET",
    headers
  );
}

export async function findEmpresaByIdCnpj(empresa_cnpj, id) {
  return search(`${path}/${id}?empresa_cnpj=${empresa_cnpj}`, "GET", headers);
}
